import { render, staticRenderFns } from "./LeavingEmployeeModal.vue?vue&type=template&id=70791f8f&"
import script from "./LeavingEmployeeModal.vue?vue&type=script&lang=ts&"
export * from "./LeavingEmployeeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports